module.exports = __webpack_public_path__ + "static/sgcc-logo-45c89d271794585f5eb244095e09aada.png";